export default "__VITE_ASSET__B_B0uAKr__"